/* global WufooForm */

export function mountPauseForm() {
    let ztofhka1ro424g;
    let defaultValues;
    const formDefaultDataContainer = document.querySelector('#wufoo-form-data');
    if (formDefaultDataContainer) {
        // @ts-expect-error
        defaultValues = formDefaultDataContainer.dataset.formDefaults;
    }

    (function (d, t) {
        const s = d.createElement(t),
            options = {
                userName: 'nutshellcrm',
                formHash: 'r19vkqwv1n8aztm',
                autoResize: true,
                height: '1687',
                async: true,
                host: 'wufoo.com',
                header: 'show',
                ssl: true,
                defaultValues: defaultValues,
            } as const;
        // @ts-expect-error
        s.src = `${
            'https:' === d.location.protocol ? 'https://' : 'http://'
        }www.wufoo.com/scripts/embed/form.js`;
        // @ts-expect-error
        s.onload = s.onreadystatechange = function () {
            // @ts-expect-error
            const rs = this.readyState;
            if (rs) if (rs !== 'complete') if (rs !== 'loaded') return;
            try {
                // @ts-expect-error
                ztofhka1ro424g = new WufooForm();
                ztofhka1ro424g.initialize(options);
                ztofhka1ro424g.display();
            } catch (_e: any) {
                // Ignoring error
            }
        };
        const scr = d.getElementsByTagName(t)[0],
            // @ts-expect-error
            par = scr.parentNode;
        if (par) {
            // @ts-expect-error
            par.insertBefore(s, scr);
        }
    })(document, 'script');
}
